import React, { useState } from 'react'
import DocReviewBg from '../../../assets/MemberBookingWizard/doc-review-bg.svg'
import LegalAdviceBg from '../../../assets/MemberBookingWizard/legal-advice-bg.svg'

import { ImClipboard } from 'react-icons/im'
import { PersonChat } from 'assets/icons/PersonChat'
import { BookingCategory } from 'common/types/MemberBooking'
import { BookingCategoryRadioOption } from 'cwp-components/CWP Sections/MemberProfile/MemberBookingWizard/BookingCategoryRadioOption'

// This code is a copy of the ModalHeader, ModalFooter and Step1BookingCategory components
// but just the HTML and CSS part, since the logic is not needed for the dummy component
// There are some minor style changes since it's not in a wizard/modal context

export const Step1BookingCategoryDummy = () => {
  return (
    <>
      <div className='flex flex-col md:flex-row md:place-items-center overflow-auto h-full justify-center'>
        <div
          className='bg-white border border-[#9FB7D7] rounded-lg shadow-md md:max-h-[90vh] md:max-w-[915px] overflow-auto'
        >
          <div className='flex justify-between items-center bg-[#ebf3ff] rounded-t-lg h-12 md:h-16 md:gap-[100px] tracking-wide flex-wrap px-6'>
            <h4 className='text-[#001A3D] md:text-[#020251] text-sm md:text-2xl font-normal md:font-bold tracking-wide'>
              Make a booking
            </h4>
            <button>
              <svg
                className='w-4 h-4 md:w-6 md:h-6'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M18 6L6 18'
                  stroke='#020251'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M6 6L18 18'
                  stroke='#020251'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          </div>
          <div className='mb-4 p-6'>
            <p className='text-[#25395C] text-sm sm:text-base font-normal sm:font-medium tracking-wide'>
              Let us know what type of booking you would like to make
            </p>
          </div>
          <div className='flex flex-col place-items-center md:flex-row justify-center gap-11 mb-4 p-6'>
            <BookingCategoryRadioOption
              titleText={BookingCategory.DOCUMENT_REVIEW}
              bodyText='Have an expert review and report back on your draft document.'
              backgroundImage={DocReviewBg}
              selected={null}
              onSelect={null}
              selectedBorderColor='border-[#65C2D7]'
              Icon={ImClipboard}
            />
            <BookingCategoryRadioOption
              titleText={BookingCategory.LEGAL_ADVICE}
              bodyText='Legal advice and representation for your legal issue.'
              backgroundImage={LegalAdviceBg}
              selected={null}
              onSelect={null}
              selectedBorderColor='border-[#7B7BDF]'
              Icon={PersonChat}
            />
          </div>
          <div className={'mt-6 flex flex-col md:flex-row justify-between gap-4 p-4'}>
            <p className='text-[10px] md:text-[12px]'>

            </p>
            <div className={'flex flex-row justify-end gap-4'}>
              <button
                type='button'
                className='rounded-[4px] !px-2 !py-1 md:p-2 md:!py-2 md:!px-4 leading-2 text-xs md:text-base md:font-medium md:leading-4 tracking-wide bg-[#020251] cursor-pointer text-white hover:text-[#65C2D7] shadow-[0px_1px_4px_0px_rgba(0,0,0,1)]'
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}